import react, { useEffect } from "react";
import { useSelector } from "react-redux";
import MemberBenefits from "./Components/Member-Benefits";
import { getAllPrograms } from "../../../store/slices/programsSlice";
import { useDispatch } from "react-redux";
const MemberBenefitsMapping = () => {
    const program = useSelector((state) => state.programs.programDetail);
    const [programDetails, setProgramDetails] = react.useState();
    const dispatch = useDispatch();
    const getAllProgramsData = async () => {
        let payload = {
            getServiceData: true,
            getSubServiceData: true,
            plan_slug: "plan001",
            getFilteredData: true,
            getBySlugName: true,
        };
        let data = await dispatch(getAllPrograms(payload));
        setProgramDetails(data?.payload[0]);
        console.log(data, "programs");
    }

    useEffect(() => {
        getAllProgramsData();
    }, []);

    return (
      <div className="p-4 m-4">
        <MemberBenefits program={program} programDetails={programDetails} />
      </div>
    );
};


export default MemberBenefitsMapping;